export function removeHttpHttps(url) {
    if (Array.isArray(url)) return url.map((item) => item.replace(/https?:\/\//, ''));
    return url.replace(/https?:\/\//, '');
}
